import React, {useState, useEffect} from 'react'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl,  staffCode,  Token, config, PortalType} from '../component/include'
import Cookies from 'js-cookie'
import './MyPassword.css'

const MyPassword =()=>{

    const [notice, setNotice] = useState({
      isLoading : false,
      isDataFetching: true
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [errors, setErrors] = useState({});

  const [content, setContent] = useState({
      code:staffCode,
      oldPassword:'',
      password:'',
      confirmPassword:''
  })  	
  
  const handleChange =(event)=>{
      const {name, value} = event.target;
      setContent({...content, [name] : value });
      setErrors({...errors, [name]:''});
  }
  

    
    
    const handleSubmit = (event) =>{
      event.preventDefault();
      setIsSubmitting(true);
      
      let errors = {};   
      
      // Check if password meets requirements
      let password = content.password.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{6,}/);
      
      if(!content.password){
          errors.password = 'Password is required';
      } else if(content.password.length < 6){
          errors.password = 'Password must be at least 6 characters';
      } else if(!password){
          errors.password = 'Password must include uppercase, lowercase, number, and special character';
      }
      
      if(!content.confirmPassword){
          errors.confirmPassword = 'Please confirm your password';
      } else if(content.password !== content.confirmPassword){
          errors.confirmPassword = 'Passwords do not match';
      }
      
      setErrors(errors);
      
      if(Object.keys(errors).length === 0){
          submit();
      } else {
          setIsSubmitting(false);
      }
  }
  

          function submit(){  
              setNotice({...notice, 
                isLoading: true})     
            
                let formData = content;
                const fd = new FormData();
                fd.append('jwt', Token);
                for(let k in formData){
                fd.append(k, formData[k])
                }
                
                 let url = ServerUrl+'/update_controller/tbl_staff_New_password'
                axios.post(url, fd, config)
                .then(response =>{
                 if(response.data.type ==='info'){
                  // Clear the reset_password cookie on successful password update
                  Cookies.set('tkrspw', 'No');
                  

                  if(PortalType==='Admin'){
                    window.open('/startup', '_self')
                }else{
                    window.open('/staffportal/dashboard', '_self')
                }

                  Alerts('Password updated successfully!', 'success', response.data.message)

                  setTimeout(() => {
                    // Redirect to logout which will clear all cookies
                    window.open('/logout', '_self')
                  }, 3000);
                    } else{
                  Alerts('Error!', 'danger', response.data)
                    }   
                })
                .catch((error)=>{
                  Alerts('Error!', 'danger', error.message)
                }).finally(()=>{
                  setNotice({...notice, isLoading: false })
                  setIsSubmitting(false);
                }) 
            }

        return (  
            <React.Fragment>
                {notice.isLoading && <LoadEffect className="overlay floatLoad" />}
                <div className="main-body">
                    <div className="page-wrapper">
                        <PageHeader title="Update Your Password">
                            <li className="breadcrumb-item"><a href="#!"><i className="fa fa-fw fa-user"></i></a></li>

                            <li className="breadcrumb-item"><a href="/logout">Logout</a></li>
                        </PageHeader>
                        
                        <div className="page-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-10 col-sm-12">
                                    <div className="password-card">
                                        <div className="password-card-header">
                                            <div className="password-card-icon">
                                                <i className="fa fa-lock"></i>
                                            </div>
                                            <h4>Change Your Password</h4>
                                            <p>Please create a strong password with at least 6 characters including uppercase, lowercase, numbers, and special characters.</p>
                                        </div>
                                        
                                        <div className="password-card-body">
                                            <form className="password-form">
                                                <div className="form-group">
                                                    <label htmlFor="account-pass">
                                                        <i className="fa fa-key"></i> New Password
                                                    </label>
                                                    <div className="input-group">
                                                        <input 
                                                            type="password" 
                                                            id="account-pass" 
                                                            placeholder="Enter new password" 
                                                            onChange={handleChange} 
                                                            role="presentation" 
                                                            autoComplete="off" 
                                                            name="password" 
                                                            value={content.password} 
                                                            className={`form-control ${errors.password ? 'is-invalid' : ''}`} 
                                                        />
                                                    </div>
                                                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                                </div>
                                                
                                                <div className="form-group">
                                                    <label htmlFor="account-confirm-pass">
                                                        <i className="fa fa-check-circle"></i> Confirm Password
                                                    </label>
                                                    <div className="input-group">
                                                        <input 
                                                            type="password" 
                                                            id="account-confirm-pass" 
                                                            placeholder="Confirm new password" 
                                                            onChange={handleChange} 
                                                            role="presentation" 
                                                            autoComplete="off" 
                                                            name="confirmPassword" 
                                                            value={content.confirmPassword} 
                                                            className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`} 
                                                        />
                                                    </div>
                                                    {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                                                </div>
                                                
                                                <div className="password-requirements">
                                                    <h5>Password Requirements:</h5>
                                                    <ul>
                                                        <li className={content.password.length >= 6 ? 'valid' : ''}>
                                                            <i className={`fa ${content.password.length >= 6 ? 'fa-check-circle' : 'fa-circle'}`}></i> 
                                                            Minimum 6 characters
                                                        </li>
                                                        <li className={/[A-Z]/.test(content.password) ? 'valid' : ''}>
                                                            <i className={`fa ${/[A-Z]/.test(content.password) ? 'fa-check-circle' : 'fa-circle'}`}></i> 
                                                            At least one uppercase letter
                                                        </li>
                                                        <li className={/[a-z]/.test(content.password) ? 'valid' : ''}>
                                                            <i className={`fa ${/[a-z]/.test(content.password) ? 'fa-check-circle' : 'fa-circle'}`}></i> 
                                                            At least one lowercase letter
                                                        </li>
                                                        <li className={/[0-9]/.test(content.password) ? 'valid' : ''}>
                                                            <i className={`fa ${/[0-9]/.test(content.password) ? 'fa-check-circle' : 'fa-circle'}`}></i> 
                                                            At least one number
                                                        </li>
                                                        <li className={/[@$!%*#?&^_-]/.test(content.password) ? 'valid' : ''}>
                                                            <i className={`fa ${/[@$!%*#?&^_-]/.test(content.password) ? 'fa-check-circle' : 'fa-circle'}`}></i> 
                                                            At least one special character
                                                        </li>
                                                    </ul>
                                                </div>
                                                
                                                <div className="form-actions">
                                                    <button 
                                                        type="button" 
                                                        onClick={handleSubmit} 
                                                        className="btn-update-password"
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? (
                                                            <>
                                                                <i className="fa fa-spinner fa-spin"></i> Processing...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="fa fa-lock"></i> Update Password
                                                            </>
                                                        )}
                                                    </button>


                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
 );
        
}

export default React.memo(MyPassword) 